export type AdminView = 'platform' | 'company' | 'region';

const ADMIN_VIEW_KEY = 'admin_view';

export const getAdminView = (): AdminView => {
  if (typeof window === 'undefined') {
    return 'company';
  }
  const value = window.localStorage.getItem(ADMIN_VIEW_KEY);
  return value === 'platform' || value === 'region' ? value : 'company';
};

export const setAdminView = (view: AdminView) => {
  if (typeof window === 'undefined') {
    return;
  }
  window.localStorage.setItem(ADMIN_VIEW_KEY, view);
};

export const inferAdminViewFromPath = (pathname: string): AdminView | undefined => {
  if (pathname.startsWith('/platform')) {
    return 'platform';
  }
  if (pathname.startsWith('/company')) {
    return 'company';
  }
  if (pathname.startsWith('/region')) {
    return 'region';
  }
  return undefined;
};

export { ADMIN_VIEW_KEY };
